import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoaderService } from '../../services/loader/loader.service';
import { Observable, asyncScheduler } from 'rxjs';
import { distinctUntilChanged, observeOn } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-loader',
  standalone: true,
  imports: [ProgressSpinnerModule, CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
  // 🔹 observeOn(asyncScheduler) defers each emission to its own macrotask,
  // so it can never fire mid-way through a change-detection pass that's
  // already checked this component — this is what caused NG0100.
  isLoading: Observable<boolean> = this.loaderService.isLoading.pipe(
    distinctUntilChanged(),
    observeOn(asyncScheduler)
  );

  constructor(private loaderService: LoaderService) {}
}